export enum FileType {
  DOCUMENT = 'DOCUMENT',
  IMAGE = 'IMAGE'
}

export class FileDTO {
  public url: string;

  public type: FileType;
}